export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Учетные формы: Паспорт архива",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
